import { useContext as z, useRef as D, useLayoutEffect as E } from "react";
import { w as j, x as L, y as q, S as G, z as W } from "./tss-DN0acMKN.mjs";
import { g as K } from "./_commonjsHelpers-BkfeUUK-.mjs";
var A = { exports: {} }, t = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var o = typeof Symbol == "function" && Symbol.for, P = o ? Symbol.for("react.element") : 60103, x = o ? Symbol.for("react.portal") : 60106, l = o ? Symbol.for("react.fragment") : 60107, p = o ? Symbol.for("react.strict_mode") : 60108, m = o ? Symbol.for("react.profiler") : 60114, S = o ? Symbol.for("react.provider") : 60109, d = o ? Symbol.for("react.context") : 60110, O = o ? Symbol.for("react.async_mode") : 60111, v = o ? Symbol.for("react.concurrent_mode") : 60111, b = o ? Symbol.for("react.forward_ref") : 60112, g = o ? Symbol.for("react.suspense") : 60113, V = o ? Symbol.for("react.suspense_list") : 60120, $ = o ? Symbol.for("react.memo") : 60115, h = o ? Symbol.for("react.lazy") : 60116, Y = o ? Symbol.for("react.block") : 60121, B = o ? Symbol.for("react.fundamental") : 60117, H = o ? Symbol.for("react.responder") : 60118, J = o ? Symbol.for("react.scope") : 60119;
function a(e) {
  if (typeof e == "object" && e !== null) {
    var r = e.$$typeof;
    switch (r) {
      case P:
        switch (e = e.type, e) {
          case O:
          case v:
          case l:
          case m:
          case p:
          case g:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case d:
              case b:
              case h:
              case $:
              case S:
                return e;
              default:
                return r;
            }
        }
      case x:
        return r;
    }
  }
}
function C(e) {
  return a(e) === v;
}
t.AsyncMode = O;
t.ConcurrentMode = v;
t.ContextConsumer = d;
t.ContextProvider = S;
t.Element = P;
t.ForwardRef = b;
t.Fragment = l;
t.Lazy = h;
t.Memo = $;
t.Portal = x;
t.Profiler = m;
t.StrictMode = p;
t.Suspense = g;
t.isAsyncMode = function(e) {
  return C(e) || a(e) === O;
};
t.isConcurrentMode = C;
t.isContextConsumer = function(e) {
  return a(e) === d;
};
t.isContextProvider = function(e) {
  return a(e) === S;
};
t.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === P;
};
t.isForwardRef = function(e) {
  return a(e) === b;
};
t.isFragment = function(e) {
  return a(e) === l;
};
t.isLazy = function(e) {
  return a(e) === h;
};
t.isMemo = function(e) {
  return a(e) === $;
};
t.isPortal = function(e) {
  return a(e) === x;
};
t.isProfiler = function(e) {
  return a(e) === m;
};
t.isStrictMode = function(e) {
  return a(e) === p;
};
t.isSuspense = function(e) {
  return a(e) === g;
};
t.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === l || e === v || e === m || e === p || e === g || e === V || typeof e == "object" && e !== null && (e.$$typeof === h || e.$$typeof === $ || e.$$typeof === S || e.$$typeof === d || e.$$typeof === b || e.$$typeof === B || e.$$typeof === H || e.$$typeof === J || e.$$typeof === Y);
};
t.typeOf = a;
A.exports = t;
var Q = A.exports, T = Q, U = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, X = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Z = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, F = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, w = {};
w[T.ForwardRef] = Z;
w[T.Memo] = F;
function _(e) {
  return T.isMemo(e) ? F : w[e.$$typeof] || U;
}
var k = Object.defineProperty, ee = Object.getOwnPropertyNames, M = Object.getOwnPropertySymbols, te = Object.getOwnPropertyDescriptor, re = Object.getPrototypeOf, R = Object.prototype;
function N(e, r, s) {
  if (typeof r != "string") {
    if (R) {
      var u = re(r);
      u && u !== R && N(e, u, s);
    }
    var c = ee(r);
    M && (c = c.concat(M(r)));
    for (var i = _(e), n = _(r), y = 0; y < c.length; ++y) {
      var f = c[y];
      if (!X[f] && !(s && s[f]) && !(n && n[f]) && !(i && i[f])) {
        var I = te(r, f);
        try {
          k(e, f, I);
        } catch {
        }
      }
    }
  }
  return e;
}
var oe = N;
const ie = /* @__PURE__ */ K(oe);
var ye = /* @__PURE__ */ L(function(e, r) {
  var s = e.styles, u = j([s], void 0, z(q)), c = D();
  return E(function() {
    var i = r.key + "-global", n = new G({
      key: i,
      nonce: r.sheet.nonce,
      container: r.sheet.container,
      speedy: r.sheet.isSpeedy
    }), y = !1, f = document.querySelector('style[data-emotion="' + i + " " + u.name + '"]');
    return r.sheet.tags.length && (n.before = r.sheet.tags[0]), f !== null && (y = !0, f.setAttribute("data-emotion", i), n.hydrate([f])), c.current = [n, y], function() {
      n.flush();
    };
  }, [r]), E(function() {
    var i = c.current, n = i[0], y = i[1];
    if (y) {
      i[1] = !1;
      return;
    }
    if (u.next !== void 0 && W(r, u.next, !0), n.tags.length) {
      var f = n.tags[n.tags.length - 1].nextElementSibling;
      n.before = f, n.flush();
    }
    r.insert("", u, n, !1);
  }, [r, u.name]), null;
});
function ne() {
  for (var e = arguments.length, r = new Array(e), s = 0; s < e; s++)
    r[s] = arguments[s];
  return j(r);
}
var ce = function() {
  var r = ne.apply(void 0, arguments), s = "animation-" + r.name;
  return {
    name: s,
    styles: "@keyframes " + s + "{" + r.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
export {
  ye as G,
  ne as c,
  ie as h,
  ce as k
};
//# sourceMappingURL=emotion-react.browser.esm-BdEGsKDn.mjs.map
